import React from "react";
import { ThreeDots } from "react-loader-spinner";
export default function ContentLoader() {
  return (
    <ThreeDots
      height="60"
      width="60"
      radius="9"
      color="var(--primary)"
      ariaLabel="three-dots-loading"
      wrapperStyle={{}}
      wrapperClassName=""
      visible={true}
    />
  );
}
